import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import slc__asset from "@/assets/restore/locations/salt-lake-city.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Salt Lake City",
    address: "222 S Main St, 5th Floor",
    img: slc__asset.url,
    mapUrl: map("222 S Main St Salt Lake City UT"),
    to: "/locations/utah/salt-lake-city/",
  },
];

export const Route = createFileRoute("/locations/utah/")({
  head: () => ({
    meta: [
      { title: "Utah Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Utah. Book a free personal hair loss consultation at our Salt Lake City location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Utah Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Salt Lake City, Utah and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/utah/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/utah/" }],
  }),
  component: () => <StateLocationsHub stateName="Utah" cities={cities} />,
});